import React, { useState, useEffect } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "../mock";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const total = testimonials.length;
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % total), 5000);
    return () => clearInterval(t);
  }, [total]);

  return (
    <section className="bg-cream bg-dotted py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">What People Say</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">Clients Feedback</h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
        </div>

        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg border border-orange-100 p-8 md:p-10 relative">
          <Quote size={48} className="text-orange-500/20 absolute top-6 left-6" />
          <div className="text-center">
            <p className="text-lg md:text-xl text-neutral-700 italic leading-relaxed">“{testimonials[idx].quote}”</p>
            <div className="mt-7 flex flex-col items-center">
              <div className="w-14 h-14 rounded-full bg-orange-500 text-white font-display text-xl flex items-center justify-center">
                {testimonials[idx].name.charAt(0)}
              </div>
              <p className="mt-3 font-display text-lg uppercase">{testimonials[idx].name}</p>
              <p className="text-sm text-orange-600">{testimonials[idx].role}</p>
            </div>
          </div>
          <button onClick={() => setIdx((idx - 1 + total) % total)} className="absolute -left-3 md:-left-5 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white border border-neutral-200 hover:bg-orange-500 hover:text-white hover:border-orange-500 transition-colors flex items-center justify-center shadow">
            <ChevronLeft size={18} />
          </button>
          <button onClick={() => setIdx((idx + 1) % total)} className="absolute -right-3 md:-right-5 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white border border-neutral-200 hover:bg-orange-500 hover:text-white hover:border-orange-500 transition-colors flex items-center justify-center shadow">
            <ChevronRight size={18} />
          </button>
        </div>
        <div className="flex items-center justify-center gap-2 mt-6">
          {testimonials.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-orange-500" : "w-2 bg-neutral-300"}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
